
export default function getMoonZodiac(date) {
  // Convert date to Julian Day Number
  const getJulianDay = (date) => {
    const a = Math.floor((14 - (date.getMonth() + 1)) / 12);
    const y = date.getFullYear() + 4800 - a;
    const m = (date.getMonth() + 1) + 12 * a - 3;
    
    const jdn = date.getDate() + Math.floor((153 * m + 2) / 5) + 365 * y + 
                Math.floor(y / 4) - Math.floor(y / 100) + Math.floor(y / 400) - 32045;
    
    const dayFraction = (date.getHours() + date.getMinutes() / 60 + date.getSeconds() / 3600) / 24;
    
    return jdn + dayFraction - 0.5;
  };
  
  const jd = getJulianDay(date);
  const T = (jd - 2451545.0) / 36525; // Julian centuries from J2000.0
  
  // Calculate Moon's mean longitude (simplified)
  const L0 = 218.31617 + 481267.88088 * T;
  
  // Moon's mean anomaly
  const M = 134.963 + 477198.868 * T;
  
  // Moon's mean elongation
  const D = 297.850 + 445267.112 * T;
  
  // Convert to radians
  const deg2rad = Math.PI / 180;
  const Mrad = M * deg2rad;
  const Drad = D * deg2rad;
  
  // Calculate ecliptic longitude with perturbations
  let lambda = L0 + 6.289 * Math.sin(Mrad);
  lambda += 1.274 * Math.sin(2 * Drad - Mrad);
  lambda += 0.658 * Math.sin(2 * Drad);
  lambda += 0.214 * Math.sin(2 * Mrad);
  
  // Normalize to 0-360
  lambda = lambda % 360;
  if (lambda < 0) lambda += 360;
  
  // Apply ayanamsa for sidereal zodiac (Lahiri ayanamsa)
  const ayanamsa = 23.85 + (T * 100 * 0.013972); // Simplified Lahiri calculation
  let siderealLongitude = lambda - ayanamsa;
  
  // Normalize again
  siderealLongitude = siderealLongitude % 360;
  if (siderealLongitude < 0) siderealLongitude += 360;
  
  // Determine zodiac sign (30 degrees each)
  const zodiacs = [
      { name: 'Aries', symbol: '♈︎', element: 'Fire', type: 'Fruit' },
      { name: 'Taurus', symbol: '♉︎', element: 'Earth', type: 'Root' },
      { name: 'Gemini', symbol: '♊︎', element: 'Air', type: 'Flower' },
      { name: 'Cancer', symbol: '♋︎', element: 'Water', type: 'Leaf' },
      { name: 'Leo', symbol: '♌︎', element: 'Fire', type: 'Fruit' },
      { name: 'Virgo', symbol: '♍︎', element: 'Earth', type: 'Root' },
      { name: 'Libra', symbol: '♎︎', element: 'Air', type: 'Flower' },
      { name: 'Scorpio', symbol: '♏︎', element: 'Water', type: 'Leaf' },
      { name: 'Sagittarius', symbol: '♐︎', element: 'Fire', type: 'Fruit' },
      { name: 'Capricorn', symbol: '♑︎', element: 'Earth', type: 'Root' },
      { name: 'Aquarius', symbol: '♒︎', element: 'Air', type: 'Flower' },
      { name: 'Pisces', symbol: '♓︎', element: 'Water', type: 'Leaf' }
  ];
  
  const zodiacIndex = Math.floor(siderealLongitude / 30);
  const degreeInSign = siderealLongitude % 30;
  const zodiac = zodiacs[zodiacIndex]
  zodiac.degreeInSign = degreeInSign
  zodiac.siderealLongitude = siderealLongitude

  return zodiac
}

